/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seats: NonNullable<unknown>, people: NonNullable<unknown> }} Receipt_MinimumInputs */



/**
* | output |
* | --- |
* | "The plan bills at least {seats} seats; the organization had {people} people." |
*
* @param {Receipt_MinimumInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const receipt_minimum = /** @type {((inputs: Receipt_MinimumInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_MinimumInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Der Tarif berechnet mindestens ${i?.seats} Plätze; die Organisation hatte ${i?.people} Personen.`)
	return /** @type {LocalizedString} */ (`The plan bills at least ${i?.seats} seats; the organization had ${i?.people} people.`)
});